module.exports = __webpack_public_path__ + "img/grab-icon.d1e18818.png";